<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tablePage="page"
      :table-data="table"
      :loading="loading"
      @submit="reload"
    >
      <page-header
        @reset="reset"
        slot="header"
        @submit="handleSubmit"
        ref="header"
      />

      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
export default {
  name: 'resourceManagement-scm-appraisalBill',
  components: {
    PageHeader: () => import('./components/header/index'),
    PageMain: () => import('./components/main')
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      }
    }
  },
  methods: {
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 20,
        pageTotal: 0
      }
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 重载表格数据
    reload() {
      this.$refs.header.query()
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .scmAppraisalBillListApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
